function getProductCards() {
  return document.querySelectorAll('.thumbnail');
}
let productCards = getProductCards();
let numOfCards = productCards.length;

/* --| State handlers |-- */
// Change card color text
function setColorTextAndPrice(button, card) {

  let waitlist = button.hasAttribute('waitlist');
  let sold_out = button.hasAttribute('sold_out');

  let isFinalSale = button.hasAttribute('final_sale');

  let waitlistElement = card.querySelector('.sold_out');
  if (waitlistElement) {
    waitlistElement.classList.add('hide');
  }

  // grab price info from the the color swatches
  let productPrice = button.getAttribute('data-price');
  let salePrice = button.getAttribute('data-sale-price');
  let comparePrice = button.getAttribute('data-compare-at-price');
  let promoPrice = button.getAttribute('data-promo-price');

  // round the promo price
  let promoPriceRounded = Math.round(Number(promoPrice));
  let promoText = button.getAttribute('data-promo-text');

  card.querySelectorAll('.collection-image-sold-out-overlay').forEach(overlay => {
    const parentImage = overlay.closest('.product_image');
    if (parentImage && parentImage.dataset.product_id != button.dataset.product_id) {
      overlay.classList.add('is-hidden');
    }
  });

  let imgSoldOutOverlay = card.querySelector(
    `.product_image[data-product_id="${button.dataset.product_id}"] .collection-image-sold-out-overlay`
  );
  let productDetails = card.querySelector('.product-details');
  let siblingDiv = card.querySelector('.variant-color');
  let priceUIDiv = card.querySelector('.price-ui[data-price-ui]');
  let promoTextElement = card.querySelector('.promo-text');
  let badgeTextWrapper = card.querySelector('.price-ui-badge');

  // Change badge text on click
  if (badgeTextWrapper) {
    badgeTextWrapper.querySelectorAll('.price-ui-badge__sticker').forEach(el => el.remove());
  }

  if (salePrice && badgeTextWrapper) {
    let newBadgeDiv = document.createElement('div');
    newBadgeDiv.innerHTML = `
      <div class="price-ui-badge__sticker data-price-ui-badge" data-price-ui>
        <span class="price-ui-badge__sticker-text" data-badge></span>
      </div>
    `;
    badgeTextWrapper.appendChild(newBadgeDiv);
    let badgeTextElement = card.querySelector('.price-ui-badge__sticker-text');
    if (badgeTextElement) {
      badgeTextElement.textContent = isFinalSale ? 'final sale' : 'sale';
    }
  }

  // Create the new price UI div element and set its HTML
  let newPriceUIDiv = document.createElement('div');
  newPriceUIDiv.innerHTML = '<div class="price-ui price-ui--loading" data-price-ui=""></div>';

  // Add section for price UI if it's not there yet
  if (!priceUIDiv) {
  // Insert the new div after the specific sibling
    if (siblingDiv) {
        productDetails.insertBefore(newPriceUIDiv.firstChild, siblingDiv.nextSibling);
    } else {
        productDetails.appendChild(newPriceUIDiv.firstChild);
    }
    // Re-query now that it's been inserted
    priceUIDiv = card.querySelector('.price-ui[data-price-ui]');
  }

  // Only create promo text element if there is actually a promo
  if (!promoTextElement && promoPriceRounded && promoText) {
    let newPromoTextDiv = document.createElement('div');
    newPromoTextDiv.innerHTML = '<p class="promo-text"><span class="money" data-price=""></span></p>';
    if (priceUIDiv) {
      productDetails.insertBefore(newPromoTextDiv.firstChild, priceUIDiv.nextSibling);
    } else {
      productDetails.appendChild(newPromoTextDiv.firstChild);
    }
  }

  // if product is sold out
  if (waitlist || sold_out) {
    if (salePrice) {
      // console.log('sold out - there IS a sale')
      if (priceUIDiv) {
        // priceUIDiv.innerHTML = '<strong>Sold Out</strong>';
        imgSoldOutOverlay.classList.remove('is-hidden');
        priceUIDiv.innerHTML =
        `<span class="price price--sale" data-price="">
          <span class="money" data-price="">$` + salePrice + `</span>
        </span>
        <span class="compare-at-price" data-compare-at-price="">
          <span class="money" data-price="">$` + comparePrice + `</span>
        </span>`
      }
    } else {
      // console.log('sold out - there is NOT a sale');
      if (priceUIDiv) {
        // priceUIDiv.innerHTML = '<strong>Sold Out</strong>';
        imgSoldOutOverlay.classList.remove('is-hidden');
        priceUIDiv.innerHTML =
        `<span class="price" data-price="">
          <span class="money" data-price="">$` + productPrice + `</span>
        </span>`
      }
    }
    // remove any promo text for sold out items
    // if (promoTextElement) {
    //   promoTextElement.innerHTML = '';
    // }
  // if product is in stock
  } else {
    if (salePrice) {
      // console.log('in stock - there IS a sale')
      priceUIDiv.innerHTML =
        `<span class="price price--sale" data-price="">
          <span class="money" data-price="">$` + salePrice + `</span>
        </span>
        <span class="compare-at-price" data-compare-at-price="">
          <span class="money" data-price="">$` + comparePrice + `</span>
        </span>`
    } else {
      // console.log('in stock - there is NOT sale')
      priceUIDiv.innerHTML =
        `<span class="price" data-price="">
          <span class="money" data-price="">$` + productPrice + `</span>
        </span>`
    }
    // if there is a promo
    if (promoPriceRounded) {
      promoTextElement.innerHTML =
      // `<p class="promo-text">
      //   Get this for
      //   <span class="money" data-price="">$` + promoPriceRounded + `</span>
      //   with code ` + promoText + `
      // </p>`
      `<p class="promo-text">
        Get this for
        <span class="money" data-price="">$` + promoPriceRounded + `</span>
        limited time only
      </p>`
    } else {
      if (promoTextElement) {
        promoTextElement.innerHTML = '';
      }
    }
  }

  // Update color name on swatch click
  // let color = button.getAttribute('data-swatch-color');
  // let colorElement = button
  //   .closest('.thumbnail')
  //   .querySelector('.variant-color');
  // colorElement.innerText = color;

}

// Simulates click on actual swatch when you click on swatches with the sold out overlay
document.addEventListener('click', function (e) {
  const overlay = e.target.closest('.swatch-sold-out-overlay');
  if (overlay) {
    const swatch = overlay.closest('.swatch');
    if (swatch) {
      swatch.click();
    }
  }
});

// Set active ring on clicked swatch
function setSelectedState(button) {
  let productSwatches =
    button.parentElement.querySelectorAll('.swatch-element');
  productSwatches.forEach(b => {
    if (b.classList.contains('c_active')) b.classList.remove('c_active');
  });

  button.classList.add('c_active');
}

// Change all variant links by clicking on swatch
function handleVariantLinkChange(button) {
  const ageContext = getContextFromUrl() || getContextFromStorage();
  try {
    let variantUrl = button.dataset.product_url;
    // console.log('Swatch Click link change. Context: ', ageContext);
    variantUrl = variantUrl.split('?age_context')[0];
    if (ageContext.length) variantUrl += `?age_context=${ageContext}`;
    const productCard = button.closest('.thumbnail');
    const cardLinks = productCard.querySelectorAll('a');
    cardLinks.forEach(l => l.setAttribute('href', variantUrl));
  } catch (err) {
    console.error(err);
    // ? [REVISIT] Combine with image swap and simply copy/replace element from other variant images
  }
}

// Change variant image by clicking on swatch
function handleShowVariantImages(card, variantId, isPrimary) {
  try {
    let variantImageContainers = card.querySelectorAll('.product_image');
    for (let imageContainer of variantImageContainers) {
      if (!isPrimary) {
        if (imageContainer.classList.contains('show')) {
          imageContainer.classList.value = 'relative product_image hide';
        }
        if (imageContainer.dataset.product_id == variantId) {
          imageContainer.classList.value = 'relative product_image show';
        }
      } else {
        /* primary/first swatch chosen */
        imageContainer.classList.value = 'relative product_image hide';
        variantImageContainers[0].classList.value =
          'relative product_image show';
      }
    }
  } catch (err) {
    console.error(err);
  }
}

// Update Product title
function updateTitle(swatch) {
  let productTitle = swatch.getAttribute('data-product-title');
  let titleElement = swatch
    .closest('.thumbnail')
    .querySelector('.title');
  titleElement.innerText = productTitle;
}

// Update Quick Add form
function updateQuickAddForm(swatch) {
  const productId = swatch.getAttribute('data-product_id');
  const quickAddBox = swatch.closest('.thumbnail').querySelector('.Size');

  // If no quick add box exists on this card, bail out
  if (!quickAddBox) return;

  const titleBox = quickAddBox.querySelector('.option_title')?.cloneNode(true);
  if (!titleBox) return;

  // Set new product data on form
  const form = swatch.closest('form');
  if (form) {
    form.setAttribute('id', `product_form_${productId}`);
  }

  // grab new image to switch drawer cart image on swatch click
  let cartImg = swatch.getAttribute('data-first-img-url');
  const thumbnail = swatch.closest('.thumbnail');
  const cartImageInput = thumbnail?.querySelector('input[name="properties[_cart_image]"]');
  if (cartImageInput) {
    cartImageInput.value = cartImg;
  }

  // remove everything from Quick Add Box, replace title
  while (quickAddBox.firstChild) {
    quickAddBox.removeChild(quickAddBox.firstChild);
  }
  quickAddBox.appendChild(titleBox);

  // Replace size links
  let sizeData = swatch.getAttribute('data-sizes');
  if (!sizeData) return;

  sizeData = sizeData.replace('-SIZES-', '');
  const sizeDataArr = sizeData.split('::');
  for (let size of sizeDataArr) {
    let variantData = size.split('++');
    let variantId = variantData[0];
    let variantSize = variantData[1];
    let variantAvailable = variantData[2];
    let avail = variantAvailable == 'true' ? 'available' : 'soldout';

    let variantSizeToDisplay;
    if (variantSize.includes('(')) {
      variantSizeToDisplay = variantSize.split('(')[0].trim();
    } else {
      variantSizeToDisplay = variantSize;
    }

    let elementToAdd = `<input type="radio" tabindex="0" aria-label="${variantSize}" value="${variantSize}">
    <div tabindex="0" value="${variantSize}" data-value="${variantSize}" data-id="${variantId}" class="swatch-element ${variantSize}-swatch ${avail}">
      <label for="swatch-0-${variantSize}-${productId}-template--${variantId}__main" class="quick-add-inactive-text">${variantSizeToDisplay}</label>
    </div>`;

    quickAddBox.insertAdjacentHTML('beforeend', elementToAdd);
  }
}

/* --| Initial data handling |-- */
// set first image set to 'primary' and add 'show' class
function setPrimaryImage(cards) {
  for (let card of cards) {
    let primarySwatch = card.querySelector('[data-primary="true"]');
    let imageElement = card.querySelector('.product_image');
    /* add Show to first image element */
    if (primarySwatch) {
      imageElement.classList.add('show');
      imageElement.setAttribute('primary', '');
      imageElement.setAttribute(
        'data-product_id',
        primarySwatch.dataset.product_id
      );
    }
  }
}
setPrimaryImage(productCards);

// move primary swatch to first position
function moveSelectedToFirst(card) {
  let swatchContainer = card.querySelector('.collection_swatches');
  let swatches = swatchContainer.querySelectorAll('.swatch-element');
  for (let swatch of swatches) {
    if (swatches[0].classList.contains('c_active')) break;
    if (swatch.classList.contains('c_active')) {
      swatchContainer.insertBefore(swatch, swatchContainer.firstChild);
    }
  }
}

let swatchesToShow = 7;
let widthCheck = window.innerWidth;
console.log('Window width: ', widthCheck);
switch (true) {
  case widthCheck < 925:
    swatchesToShow = 3;
    break;
  case widthCheck < 1100:
    swatchesToShow = 4;
    break;
  case widthCheck < 1250:
    swatchesToShow = 5;
    break;
  case widthCheck < 1350:
    swatchesToShow = 6;
}
console.log('Swatches to show: ', swatchesToShow);
// remove excess swatches and add counter
function setSwatchCounter(swatchContainer, swatchesToShow) {
  let swatches = swatchContainer.querySelectorAll('.swatch-element');
  let plusNum = swatches.length - swatchesToShow;
  if (plusNum > 0) {
    removeNum = plusNum;
    while (removeNum > 0) {
      swatchContainer.removeChild(swatchContainer.lastElementChild);
      removeNum--;
    }
    let numNode = document.createElement('div');
    numNode.classList.add('plus-more');
    numNode.innerText = `+${plusNum}`;
    swatchContainer.appendChild(numNode);
  }
  swatchContainer.classList.contains('invisible')
    ? swatchContainer.classList.remove('invisible')
    : '';
}

// Add hidden image elements to show on swatch selection; add event listeners and actions
function createImageElements(cards) {
  console.log('# of Product cards: ', numOfCards);
  for (let card of cards) {
    let productIds = [];
    let imageElements = card.querySelectorAll('.product_image');
    for (let imageElement of imageElements) {
      productIds.push(imageElement.dataset.product_id);
    }

    let imageElement = card.querySelector('.product_image');
    /* clone image element with alt images */
    let swatches = card.querySelectorAll('.selector');
    swatches.forEach(s => {
      let hasImage = false;
      let productId = s.dataset.product_id;
      if (productIds.includes(productId)) hasImage = true;

      if (!hasImage) {
        let isPrimary = s.dataset.primary;
        if (isPrimary) {
          s.setAttribute('selected', '');
          s.setAttribute('data-button-primary', '');
        } else {
          let clonedNode = imageElement.cloneNode(true);
          clonedNode.classList.contains('show')
            ? clonedNode.classList.remove('show')
            : '';
          clonedNode.classList.add('hide');
          clonedNode.setAttribute('data-product_id', s.dataset.product_id);
          let nodeImages = clonedNode.querySelectorAll('img');
          nodeImages.forEach(ni => {
            ni.classList.remove('transition--fade-in');
          });
          nodeImages[0].setAttribute('src', s.dataset.firstImgUrl);
          nodeImages[0].setAttribute('data-src', s.dataset.firstImgUrl);
          nodeImages[0].setAttribute('srcset', s.dataset.firstImgSrcset);
          nodeImages[0].setAttribute('data-srcset', s.dataset.firstImgSrcset);
          nodeImages[0].setAttribute('loading', 'lazy');
          if (nodeImages[1]) {
            nodeImages[1].setAttribute('src', s.dataset.secondImgUrl);
            nodeImages[1].setAttribute('data-src', s.dataset.secondImgUrl);
            nodeImages[1].setAttribute('srcset', s.dataset.secondImgSrcset);
            nodeImages[1].setAttribute('data-srcset', s.dataset.secondImgSrcset);
            // nodeImages[1].setAttribute('loading', 'lazy');
          }
          imageElement.after(clonedNode);
        }
      }
    });

    /* Set swatch button event listeners and actions */
    swatches.forEach(s => {
      s.addEventListener('click', e => {
        let button = e.target;
        if (!button.classList.contains('swatch'))
          button = e.target.parentElement;

        let card = button.closest('.thumbnail');

        // console.log('Button element clicked: ', button);

        handleVariantLinkChange(button);
        handleShowVariantImages(
          button.closest('.thumbnail'),
          button.dataset.product_id,
          button.hasAttribute('data-button-primary')
        );
        setSelectedState(button.parentElement);
        setColorTextAndPrice(button, card);
        updateTitle(button);
        updateQuickAddForm(button);
      });
    });

    moveSelectedToFirst(card);
    // Set num of swatches to show, remove swatches, add plus
    let swatchContainer = card.querySelector('.collection_swatches');
    setSwatchCounter(swatchContainer, swatchesToShow);

    let activeSwatch = card.querySelector('.selector.c_active') ||
                      card.querySelector('[data-primary="true"]');
    if (activeSwatch) {
      setColorTextAndPrice(activeSwatch, card);
    }

  }
}
createImageElements(productCards);

// Initialize sizes on page load (use primary or active swatch)
productCards.forEach(card => {
  let initialSwatch =
    card.querySelector('.swatch-element.c_active .swatch') ||
    card.querySelector('[data-primary="true"]');

  if (initialSwatch) {
    updateQuickAddForm(initialSwatch);
  }
});
